"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = checkAddressBar;
function checkAddressBar() {
    // Создаём два временных элемента
    const vhTest = document.createElement('div');
    const percentTest = document.createElement('div');
    // Задаём высоту для каждого элемента
    vhTest.style.height = '100vh';
    percentTest.style.height = '100%';
    // Скрываем элементы
    vhTest.style.visibility = percentTest.style.visibility = 'hidden';
    vhTest.style.position = percentTest.style.position = 'absolute';
    // Добавляем элементы в документ
    document.body.appendChild(vhTest);
    document.body.appendChild(percentTest);
    // Получаем их высоту
    const vhHeight = vhTest.offsetHeight;
    const percentHeight = percentTest.offsetHeight;
    // Убираем элементы из DOM
    document.body.removeChild(vhTest);
    document.body.removeChild(percentTest);
    // Если высоты отличаются, адресная строка скрывает часть пространства
    if (percentHeight < vhHeight) {
        document.documentElement.classList.add('mobile-address-bar');
        document.documentElement.style.setProperty('--address-bar-height', `${Math.abs(vhHeight - percentHeight)}px`);
    }
    else {
        document.documentElement.classList.remove('mobile-address-bar');
        document.documentElement.style.setProperty('--address-bar-height', `0px`);
    }
}
